import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const SubscriberPanel = ({ subscribers, onExport, onSearch }) => {
  const [searchQuery, setSearchQuery] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  const filteredSubscribers = subscribers?.filter(sub =>
    sub?.email?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
    sub?.name?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  const totalPages = Math.ceil(filteredSubscribers?.length / itemsPerPage);
  const startIndex = (currentPage - 1) * itemsPerPage;
  const paginatedSubscribers = filteredSubscribers?.slice(startIndex, startIndex + itemsPerPage);

  const handleSearch = (e) => {
    setSearchQuery(e?.target?.value);
    setCurrentPage(1);
    if (onSearch) onSearch(e?.target?.value);
  };

  const formatDate = (dateString) => {
    const options = { year: 'numeric', month: 'short', day: 'numeric' };
    return new Date(dateString)?.toLocaleDateString('en-US', options);
  };

  return (
    <div className="bg-card border border-border rounded-lg shadow-elevation-sm p-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="text-lg font-heading font-semibold text-foreground">Recent Subscribers</h3>
        <Button
          variant="outline"
          size="sm"
          onClick={onExport}
          iconName="Download"
          iconPosition="left"
          iconSize={14}
        >
          Export
        </Button>
      </div>
      <div className="mb-4">
        <Input
          type="search"
          placeholder="Search subscribers..."
          value={searchQuery}
          onChange={handleSearch}
          className="w-full"
        />
      </div>
      <div className="space-y-3">
        {paginatedSubscribers?.map((subscriber) => (
          <div key={subscriber?.id} className="flex items-center justify-between p-3 bg-muted/30 rounded-lg hover:bg-muted/50 transition-colors">
            <div className="flex items-center gap-3 flex-1 min-w-0">
              <div className="flex items-center justify-center w-10 h-10 bg-primary/10 rounded-full flex-shrink-0">
                <Icon name="User" size={18} color="var(--color-primary)" />
              </div>
              <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-foreground truncate">{subscriber?.name}</p>
                <p className="text-xs text-muted-foreground truncate">{subscriber?.email}</p>
              </div>
            </div>
            <div className="flex items-center gap-2 text-xs text-muted-foreground flex-shrink-0 ml-2">
              <Icon name="Calendar" size={12} />
              <span>{formatDate(subscriber?.joinedDate)}</span>
            </div>
          </div>
        ))}
      </div>
      {totalPages > 1 && (
        <div className="flex items-center justify-between mt-4 pt-4 border-t border-border">
          <p className="text-sm text-muted-foreground">
            Showing {startIndex + 1}-{Math.min(startIndex + itemsPerPage, filteredSubscribers?.length)} of {filteredSubscribers?.length}
          </p>
          <div className="flex items-center gap-2">
            <Button
              variant="outline"
              size="sm"
              onClick={() => setCurrentPage(prev => Math.max(1, prev - 1))}
              disabled={currentPage === 1}
              iconName="ChevronLeft"
              iconSize={14}
            >
              Previous
            </Button>
            <span className="text-sm text-muted-foreground px-2">
              Page {currentPage} of {totalPages}
            </span>
            <Button
              variant="outline"
              size="sm"
              onClick={() => setCurrentPage(prev => Math.min(totalPages, prev + 1))}
              disabled={currentPage === totalPages}
              iconName="ChevronRight"
              iconPosition="right"
              iconSize={14}
            >
              Next
            </Button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SubscriberPanel;